import { useState, useEffect, useCallback } from "react";

const debounceTime = 400;
const oneMediaToken = 135;
const charactersPerToken = 4;

const useTokenCalculator = (
  text,
  mediaFiles = [],
  totalCredits = 20,
  wordCount = 500,
  segmentCount = 4
) => {
  const [tokenCount, setTokenCount] = useState(0);
  const [isCalculating, setIsCalculating] = useState(false);
  const [isWithinLimit, setIsWithinLimit] = useState(true);

  const [AISegmentTokens, setAISegmentTokens] = useState(0);
  const [AImediaTokens, setAIMediaTokens] = useState(0);

  const calculateTokens = useCallback(() => {
    // if (!text) {
    //   setTokenCount(0);
    //   setAISegmentTokens(0);
    //   setIsWithinLimit(true);
    //   return;
    // }

    setIsCalculating(true);

    setTimeout(() => {
      try {

        const characterCount = text?.length || 0;

        const promptTokens = characterCount / charactersPerToken;
        const roundedPromptTokens = promptTokens === 0 ? 0 : Math.ceil(promptTokens / 1000) + 1;

        const tokensPerWord = 1.33;
        const totalWords = wordCount * segmentCount;
        const segmentTokens = totalWords * tokensPerWord;
        const segmentIyugaTokens = Math.ceil(segmentTokens / 1000) + 1;

        let mediaTokens = 0;
        if (mediaFiles.length > 0) {
          mediaTokens = ((oneMediaToken * mediaFiles.length) / 1000) + 1;
        }

        const totalTokensUsed = Math.ceil(
          roundedPromptTokens + segmentIyugaTokens + mediaTokens
        );

        const withinLimit = totalTokensUsed <= totalCredits;

        setAISegmentTokens(segmentIyugaTokens);
        setAIMediaTokens(mediaTokens + roundedPromptTokens);
        setTokenCount(totalTokensUsed);
        setIsWithinLimit(withinLimit);
      } catch (err) {
        console.log("error", err);
      } finally {
        setIsCalculating(false);
      }
    }, 0);
  }, [text, totalCredits, mediaFiles.length, segmentCount, wordCount]);

  useEffect(() => {
    const handler = setTimeout(() => {
      calculateTokens();
    }, debounceTime);

    return () => {
      clearTimeout(handler);
    };
  }, [calculateTokens, text, mediaFiles.length, segmentCount, wordCount]);

  return {
    tokenCount,
    isCalculating,
    isWithinLimit,
    AISegmentTokens,
    AImediaTokens,
  };
};

export default useTokenCalculator;
